import { ContentBlockDto } from '../content-block.dto';

export class ContentBlockAttachement {
    private readonly icons: Record<ContentBlockAttachement['extension'], IconType> = {
        PDF: 'document',
    };
    readonly extension = 'PDF';
    readonly title: string;
    readonly size: number;
    readonly url: string;
    readonly icon = this.icons[this.extension];
    readonly type = 'attaches';

    constructor({ data }: ContentBlockDto) {
        this.title = data.title || '';
        this.size = data.file.size || 0;
        this.url = data.file.url ?? '';
    }
}
